import { SystemFolderClosedIcon } from '@commenda/icons/folder-icons';
import { cn } from '@commenda/utils';

import { AttachmentPill } from './AttachmentPill';
import { ChatAttachmentHelper } from './ChatAttachmentHelper';

interface AttachmentPillGroupItem {
  key: string;
  fileName: string;
  mimeType: string;
  fileRef?: string;
  onRemove?: () => void;
}

interface AttachmentPillGroupsProps {
  items: AttachmentPillGroupItem[];
  align?: 'start' | 'end';
}

const FOLDER_MIME_TYPE = 'inode/directory';

export function AttachmentPillGroups({
  items,
  align = 'start',
}: AttachmentPillGroupsProps) {
  const { files, folders } = ChatAttachmentHelper.splitByFolder(items);

  return (
    <div
      className={cn(
        'flex flex-wrap items-center gap-sm',
        align === 'end' && 'justify-end'
      )}
    >
      {files.map((item) => (
        <AttachmentPill
          key={item.key}
          fileName={item.fileName}
          mimeType={item.mimeType}
          fileRef={item.fileRef}
          onRemove={item.onRemove}
        />
      ))}
      {folders.map((folder) => {
        const removable = folder.items.filter((item) => item.onRemove);

        return (
          <AttachmentPill
            key={`folder:${folder.name}`}
            fileName={folder.name}
            mimeType={FOLDER_MIME_TYPE}
            icon={<SystemFolderClosedIcon />}
            onRemove={
              removable.length > 0
                ? () => removable.forEach((item) => item.onRemove?.())
                : undefined
            }
          />
        );
      })}
    </div>
  );
}
